import { type JSX } from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * The retired `/portal/cases/:caseId/*` addresses, forwarded to the surviving case view.
 *
 * These are not legacy tidiness: `notifications.link_url` rows written before the retirement
 * still name `/portal/...`, and those rows outlive the code. A bookmark or an email from
 * months ago must land somewhere real, and this product has already shipped a dead
 * notification link once.
 *
 * `replace` so the retired address never enters history — a back button that returns to a
 * redirect loops.
 */
export function PortalRedirect({ to }: { readonly to?: string }): JSX.Element {
  const { caseId = '' } = useParams();
  const base = `/cases/${caseId}`;
  return <Navigate to={to === undefined ? base : `${base}/${to}`} replace />;
}
